module.exports = __webpack_public_path__ + "assets/img/FeaturedPankou.021a06ab.png";